import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Button, Form, Grid, Image, Container, Card, Message} from 'semantic-ui-react';

import auth from "../../data/auth";
import resources from "../../data/resources";
import Toast from "../../components/extras/Toast";
import {connect} from "react-redux";
import {showToast} from "../../actions/ToastAction";
import localDB from "../../data/localDB";

const logo = require('../../img/logo_text1.svg');

class ResetPassword extends Component {

    constructor() {
        super();

        this.state = {
            email: '',
            email_error: false,
            loading: false
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        localDB.cleanSession();
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value.toLowerCase().trim()});
        if (event.target.value.trim() === '') {
            this.setState({email_error: true})
        } else {
            this.setState({email_error: false})
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.email === "" || !resources.validators.isValidEmailAddress(this.state.email)) {
            this.setState({email_error: true})
        } else {
            this.setState({loading: true});
            auth.resetPassword({email:this.state.email}, (res) => {
                if(res.hasOwnProperty('reset')){
                    if(res.reset){
                        this.props.showToast({message:'Se ha enviado un email con las instrucciones', type:'success'});
                    }else {
                        this.props.showToast({message:'No existe ningun usuario con ese email!', type:'error'});
                    }
                }else{
                    this.props.showToast({message:'Tenemos un problema!', type:'error'});
                }
                this.setState({loading: false, email:'', email_error:false});
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: 'calc(100vh)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Toast ref='toast'/>
                <Helmet>
                    <title>Quipuu - Recordar Contraseña</title>
                    <meta name="description" content="Recupera la contraseña de tu cuenta con nuestro servicio de recuperación de contraseña. Esta es la solución fácil y segura para recuperar tu acceso a la cuenta."></meta>
                </Helmet>
                <Grid>
                    <Grid.Row columns={2} centered>
                        <Grid.Column mobile={16} tablet={8} computer={7} largeScreen={6} widescreen={6}>
                            <Container>
                                <Image centered src={logo} alt="Quipuu" size='middle' style={{'width': '60%'}}/>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>¿Olvidaste tu contraseña?</Card.Header>
                                    </Card.Content>
                                    <Card.Content>
                                        <Card.Meta>Para restaurar tu contraseña, ingresa tu dirección de correo electrónico. Es posible que tengas que consultar tu carpeta de spam.</Card.Meta>
                                        <br/>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Form.Field>
                                                <Form.Input icon='mail' iconPosition='left'
                                                            type='email'
                                                            placeholder='Correo Electrónico' value={this.state.email}
                                                            onChange={this.handleEmailChange} error={this.state.email_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Button fluid type="submit" primary disabled={this.state.loading}
                                                        loading={this.state.loading}>Recuperar Contraseña</Button>
                                            </Form.Field>
                                        </Form>
                                        <p>
                                            <br/>
                                            ¿Ya tienes tu cuenta?<span  className='link' onClick={()=>this.props.history.push('/login')}> Ingresa aquí</span>
                                        </p>
                                    </Card.Content>
                                </Card>
                                <Message>
                                    <strong>
                                        ¿Tienes un negocio?,<span className='link' onClick={()=>this.props.history.push('/register')}> crea una cuenta!</span>
                                    </strong>
                                </Message>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ResetPassword)


// WEBPACK FOOTER //
// ./src/containers/main/ResetPassword.js